import React from "react";
import { Row, Col, Typography, Space, Button, Modal } from "antd";
import { ButtonTypes } from "../../../../types/TripTypes";
import Styles from "./NoReturnTripPopup.module.scss";
import { useWindowSize } from "../../../../hooks/useWindowSize";
import { GeneralDefinition } from "../../../../types/ApplicationTypes";

type Props = {
    isReturnTripNotAdded: boolean;
    btnAllEnable: ButtonTypes;
    handleReturnTripNotCancelBtnClicked: () => void;
    handleReturnTripAdded: () => void;
    handleReturnTripContinueAdded: () => void;
};

const NoReturnTripPopup: React.FC<Props> = ({
    isReturnTripNotAdded,
    btnAllEnable,
    handleReturnTripNotCancelBtnClicked,
    handleReturnTripAdded,
    handleReturnTripContinueAdded
}) => {
    const { width } = useWindowSize();

    return width > GeneralDefinition.MobileView ? (
        <Modal
            onOk={handleReturnTripNotCancelBtnClicked}
            onCancel={handleReturnTripNotCancelBtnClicked}
            visible={isReturnTripNotAdded}
            okButtonProps={{ hidden: true }}
            cancelButtonProps={{ hidden: true }}
            centered={true}
            width={800}
            footer={
                <Row className={Styles.modalContainer}>
                    <Col span={24}>
                        <Row justify="center">
                            <Typography.Text className={Styles.modalHeader}>
                                No Return Trip Added
                            </Typography.Text>
                        </Row>
                        <Row justify="center" className={Styles.returnTripSection}>
                            <Typography.Text className={Styles.modalReturnBodyText}>
                                You haven't added a return trip to this booking.
                            </Typography.Text>
                        </Row>
                        <Row justify="center" className={Styles.returnTripSection}>
                            <Typography.Text className={Styles.modalReturnBodyText}>
                                Are you sure you want to continue without a return trip?
                            </Typography.Text>
                        </Row>
                        <Row justify="center" className={Styles.returnTripButtonSection}>
                            <Col>
                                <Space className={Styles.modalBtn}>
                                    <Button
                                        className={Styles.buttonThemeBlackBorder}
                                        onClick={handleReturnTripNotCancelBtnClicked}
                                    >
                                        Cancel
                                    </Button>
                                    {(!btnAllEnable.skipReturnTrip || btnAllEnable.addReturnTrip) && (
                                        <Button
                                            className={Styles.buttonTheme}
                                            onClick={handleReturnTripAdded}
                                        >
                                            Add Return Trip
                                        </Button>
                                    )}
                                    <Button
                                        className={Styles.buttonThemeContinueWidthCustom}
                                        onClick={handleReturnTripContinueAdded}
                                    >
                                        Continue Without Return Trip
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            }
        />
    ) : (
        <Modal
            onOk={handleReturnTripNotCancelBtnClicked}
            onCancel={handleReturnTripNotCancelBtnClicked}
            visible={isReturnTripNotAdded}
            okButtonProps={{ hidden: true }}
            cancelButtonProps={{ hidden: true }}
            centered={true}
            width={800}
            footer={
                <Row className={Styles.modalContainer}>
                    <Col span={24}>
                        <Row justify="center">
                            <Typography.Text className={Styles.modalHeader}>
                                No Return Trip Added
                            </Typography.Text>
                        </Row>
                        <Row justify="center" className={Styles.returnTripSection}>
                            <Typography.Text className={Styles.modalReturnBodyText}>
                                You haven't added a return trip to this booking.
                            </Typography.Text>
                        </Row>
                        <Row justify="center" className={Styles.returnTripSection}>
                            <Typography.Text className={Styles.modalReturnBodyText}>
                                Are you sure you want to continue without a return trip?
                            </Typography.Text>
                        </Row>
                        <Row justify="center" className={Styles.returnTripButtonSection}>
                            <Col className={Styles.modalBtn}>
                                <Row justify="center" className={Styles.cancelButtonSection}>
                                    <Button
                                        className={Styles.buttonThemeBlackBorder}
                                        onClick={handleReturnTripNotCancelBtnClicked}
                                    >
                                        Cancel
                                    </Button>
                                </Row>
                                {(!btnAllEnable.skipReturnTrip || btnAllEnable.addReturnTrip) && (
                                    <Row justify="center" className={Styles.cancelButtonSection}>
                                        <Button
                                            className={Styles.buttonTheme}
                                            onClick={handleReturnTripAdded}
                                        >
                                            Add Return Trip
                                        </Button>
                                    </Row>
                                )}
                                <Row justify="center" className={Styles.continueButtonSection}>
                                    <Button
                                        className={Styles.buttonThemeBlue}
                                        onClick={handleReturnTripContinueAdded}
                                    >
                                        Continue
                                    </Button>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            }
        />
    );
};

export default NoReturnTripPopup;
